import { StarsEffects } from "./effects/stars/stars.effects";

export const metaEffects = [
    
    StarsEffects
]